export const getTrainingProgramsConfig = () =>
    `query getTrainingProgramsConfig {
        trainingProgramsConfig {
            id
            applicableLocationsConfig {
                enableApplicableLocations
            }
            trainerAppConfig {
                allowActions
                enableOperatorSignature
                enableTrainerSignature
                enableUploadEvidence
                taskTypesWithEvidence {
                    taskType
                    evidenceRequired
                }
            }
        }
    }`;

export const updateTrainingProgramsConfig = () =>
    `mutation updateTrainingProgramsConfig($configuration: TrainingProgramsConfigInput!) {
        updateTrainingProgramsConfig(configuration: $configuration)
    }`;
